export function handleManualConfigsHelper(manualConfigs: any, setctx: any) {
  setctx((ctx: any) => {
    return { ...ctx, manualConfigs }
  })
}
export function handleRollUnderHelper(rollUnder: string, setctx: any) {
  setctx((ctx: any) => {
    return { ...ctx, rollUnder }
  })
}
export function handleSliderValueHelper(sliderValue: string, setctx: any) {
  setctx((ctx: any) => {
    return { ...ctx, sliderValue }
  })
}
export function handleStakeHelper(stake: string, setctx: any) {
  const newStake = stake ? stake : '0.00'
  setctx((ctx: any) => {
    return {
      ...ctx,
      stake: newStake,
    }
  })
}
export function handleBaseStakeHelper(baseStake: string, setctx: any) {
  setctx((ctx: any) => {
    return { ...ctx, baseStake }
  })
}
export function handleConfigHelper(configs: any, name: string, setctx: any) {
  setctx((ctx: any) => {
    return { ...ctx, [name]: configs }
  })
}
